<template>
  <footer class="pt-3 text-center v2-footer" :class="[v2FooterStyleClasses]">
    <div class="mx-auto">
      <a :href="$t('message.common.autoVerifyHomeLink')" rel="noopener" target="_blank" class="footer-link">
        <span class="text-muted align-middle mr-2">{{ $t('message.trade.poweredByBB') }}</span>
        <img :src="require('@/assets/av-logo.svg')" alt="AV logo" width="84" height="14" />
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'V2Footer',
  computed: {
    v2FooterStyleClasses() {
      return this.$route.meta.v2FooterStyleClasses;
    },
  },
};
</script>

<style lang="scss" scoped>
footer.v2-footer {
  font-size: 10px;
  height: 50px;
  &.grey {
    background-color: #f0f4f7;
  }
  .footer-link:hover {
    text-decoration: none;
  }
}
</style>
